import React from 'react';
import PropTypes from 'prop-types';
import { PageLevelNotification } from '@americanexpress/dls-react';

const HotelInsiderTip = ({ tip = '' }) => {
  if (!tip) return null;

  return (
    <PageLevelNotification
      type="info"
      // eslint-disable-next-line jsx-a11y/heading-has-content -- heading text is the label
      headingSlot={<h3>Insider tip</h3>}
      isDismissible={false}
      className="margin-4-t"
    >
      <p>{tip}</p>
    </PageLevelNotification>
  );
};

HotelInsiderTip.propTypes = {
  tip: PropTypes.string,
};

export default HotelInsiderTip;
